import { Designer } from 'src/shared/constants/FeatureFlag';
import { useTreatment } from 'src/shared/hooks';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

import { useHomeownerAppContext } from './useHomeownerAppContext';

export const useIsProductCatalogPromptsEnabled = () => {
  const { user } = useHomeownerAppContext();

  // Our test prompt infrastructure is not ready for product catalog prompts
  // As a temporary solution, we are disabling product catalog prompts for users
  // matching our testing account pattern
  if (
    user?.email?.endsWith('+testing_only@hoverinc.com') ||
    user?.email?.endsWith('+testing_included@hoverinc.com')
  )
    return false;

  return true;
};

export const useIsMaterialCalloutsEnabled = () => {
  const isMaterialCalloutsEnabled = isEnabled(
    useTreatment(Designer.MATERIAL_CALLOUTS),
  );
  const isProductCatalogPromptsEnabled = useIsProductCatalogPromptsEnabled();

  return isProductCatalogPromptsEnabled && isMaterialCalloutsEnabled;
};

export const useIsMaterialCalloutsPhase2Enabled = () => {
  const isMaterialCalloutsPhase2Enabled = isEnabled(
    useTreatment(Designer.MATERIAL_CALLOUTS_PHASE_2),
  );
  const isProductCatalogPromptsEnabled = useIsProductCatalogPromptsEnabled();

  return isProductCatalogPromptsEnabled && isMaterialCalloutsPhase2Enabled;
};
